import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6f9376d6")

_pushScopeId("data-v-6f9376d6")
const _hoisted_1 = { class: "square-buttons" }
const _hoisted_2 = { class: "square-end-buttons" }
const _hoisted_3 = { class: "circular-border" }
const _hoisted_4 = {
  key: 0,
  class: "circle-buttons"
}
const _hoisted_5 = {
  key: 1,
  class: "circle-buttons-skeleton"
}
const _hoisted_6 = {
  key: 2,
  class: "info"
}
const _hoisted_7 = { class: "establishment-name" }
const _hoisted_8 = { class: "order-info" }
const _hoisted_9 = {
  key: 0,
  class: "delivery-info"
}
const _hoisted_10 = {
  key: 1,
  class: "minimum-value"
}
const _hoisted_11 = { class: "delivery-info" }
const _hoisted_12 = { id: "tags" }
const _hoisted_13 = {
  key: 0,
  class: "message"
}
const _hoisted_14 = {
  key: 3,
  class: "info-skeleton"
}
const _hoisted_15 = {
  key: 4,
  class: "freeShippingBy"
}
const _hoisted_16 = { class: "content" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "closed-establishment" }, [
  /*#__PURE__*/_createVNode("span", null, "Estabelecimento fechado!")
], -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "button-text" }, "Carrinho", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("span", { class: "separator" }, " | ", -1)
const _hoisted_20 = { class: "cart-sum" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_skeleton_text = _resolveComponent("ion-skeleton-text")
  const _component_ion_avatar = _resolveComponent("ion-avatar")
  const _component_ion_badge = _resolveComponent("ion-badge")
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")
  const _component_ion_segment = _resolveComponent("ion-segment")
  const _component_ion_list_header = _resolveComponent("ion-list-header")
  const _component_ProductCard = _resolveComponent("ProductCard")
  const _component_ion_item = _resolveComponent("ion-item")
  const _component_ion_list = _resolveComponent("ion-list")
  const _component_product_card_skeleton = _resolveComponent("product-card-skeleton")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_footer = _resolveComponent("ion-footer")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_content, { ref: "content" }, {
        default: _withId(() => [
          (!$setup.loadingRef)
            ? (_openBlock(), _createBlock("header", {
                key: 0,
                style: {
          backgroundImage: $setup.establishmentRef.background
            ? `url(https://storage.googleapis.com/thelivery/img/background/${$setup.establishmentRef.background})`
            : '',
        }
              }, [
                _createVNode("div", _hoisted_1, [
                  _createVNode(_component_ion_button, {
                    class: "button-header",
                    fill: "clear",
                    onClick: $setup.goBack
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.arrowBack,
                        color: "light"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode("div", _hoisted_2, [
                    _createVNode(_component_ion_button, {
                      class: "button-header",
                      fill: "clear",
                      onClick: $options.likeEstablishment
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_icon, {
                          icon: $setup.heart,
                          color: $setup.colorRef
                        }, null, 8, ["icon", "color"])
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_ion_button, {
                      class: "button-header",
                      fill: "clear",
                      onClick: $options.shareEstablishment
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_icon, {
                          icon: $setup.shareOutline,
                          color: "light"
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ])
              ], 4))
            : (_openBlock(), _createBlock(_component_ion_skeleton_text, {
                key: 1,
                class: "header-skeleton",
                animated: ""
              })),
          _createVNode("div", _hoisted_3, [
            (!$setup.loadingRef)
              ? (_openBlock(), _createBlock("div", _hoisted_4, [
                  _createVNode(_component_ion_button, {
                    class: "circle-button",
                    fill: "solid",
                    color: "light",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.goEstablishmentInfo()))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.informationCircleOutline,
                        color: "medium"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_avatar, null, {
                    default: _withId(() => [
                      _createVNode("img", {
                        src: 
                $setup.establishmentRef.logo
                  ? `https://storage.googleapis.com/thelivery/img/clients/${$setup.establishmentRef.logo}`
                  : ''
              ,
                        class: "establishment-logo",
                        alt: "logotipo do estabelecimento"
                      }, null, 8, ["src"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_button, {
                    class: "circle-button",
                    fill: "solid",
                    color: "light",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.goRatings()))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.star,
                        color: "warning"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_5, [
                  _createVNode(_component_ion_skeleton_text, {
                    class: "circle-button-skeleton",
                    animated: ""
                  }),
                  _createVNode(_component_ion_skeleton_text, {
                    class: "ion-avatar-skeleton",
                    animated: ""
                  }),
                  _createVNode(_component_ion_skeleton_text, {
                    class: "circle-button-skeleton",
                    animated: ""
                  })
                ])),
            (!$setup.loadingRef)
              ? (_openBlock(), _createBlock("div", _hoisted_6, [
                  _createVNode("h3", _hoisted_7, _toDisplayString($setup.establishmentRef.name), 1),
                  _createVNode("div", _hoisted_8, [
                    ($setup.establishmentRef.deliveryFee)
                      ? (_openBlock(), _createBlock("p", _hoisted_9, [
                          _createVNode(_component_ion_icon, {
                            class: "icon",
                            icon: $setup.bicycle
                          }, null, 8, ["icon"]),
                          _createTextVNode(" " + _toDisplayString($setup.establishmentRef.deliveryFee?.delivery_fee == 0
                  ? "Grátis"
                  : $options.moneyMask($setup.establishmentRef.deliveryFee?.delivery_fee)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    ($setup.establishmentRef.minimum_value)
                      ? (_openBlock(), _createBlock("p", _hoisted_10, " Pedido mínimo: " + _toDisplayString($options.moneyMask($setup.establishmentRef.minimum_value)), 1))
                      : _createCommentVNode("", true),
                    _createVNode("p", _hoisted_11, [
                      _createVNode(_component_ion_icon, {
                        class: "icon",
                        icon: $setup.timeOutline
                      }, null, 8, ["icon"]),
                      _createTextVNode(" " + _toDisplayString($setup.establishmentRef.average_time) + " min ", 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_12, [
                    ($setup.establishmentRef.cashback)
                      ? (_openBlock(), _createBlock(_component_ion_badge, {
                          key: 0,
                          class: "cashback"
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString($setup.establishmentRef.cashback) + " CASHBACK", 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    ($setup.establishmentRef.coupon)
                      ? (_openBlock(), _createBlock(_component_ion_badge, {
                          key: 1,
                          class: "coupon"
                        }, {
                          default: _withId(() => [
                            _createTextVNode("CUPOM DE " + _toDisplayString($setup.establishmentRef.coupon), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  ($setup.establishmentRef.message)
                    ? (_openBlock(), _createBlock("div", _hoisted_13, [
                        _createVNode("p", null, _toDisplayString($setup.establishmentRef.message), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_14, [
                  _createVNode(_component_ion_skeleton_text, {
                    class: "establishment-name-skeleton",
                    animated: ""
                  }),
                  _createVNode(_component_ion_skeleton_text, {
                    class: "order-info-skeleton",
                    animated: ""
                  }),
                  _createVNode(_component_ion_skeleton_text, { animated: "" })
                ])),
            (!$setup.loadingRef && $setup.establishmentRef.free_shipping_by)
              ? (_openBlock(), _createBlock("div", _hoisted_15, [
                  _createVNode(_component_ion_icon, {
                    color: "primary",
                    icon: $setup.flame
                  }, null, 8, ["icon"]),
                  _createVNode("div", null, [
                    _createVNode("span", null, "Economize " + _toDisplayString($options.moneyMask($setup.establishmentRef.deliveryFee?.delivery_fee)), 1),
                    _createVNode("span", null, "Frete grátis para pedidos a partir de " + _toDisplayString($options.moneyMask($setup.establishmentRef.free_shipping_by)), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_16, [
              (!$setup.loadingRef)
                ? (_openBlock(), _createBlock(_component_ion_segment, {
                    key: 0,
                    scrollable: "",
                    mode: "md",
                    value: "0"
                  }, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.establishmentRef.productTypes, (category, index) => {
                        return (_openBlock(), _createBlock(_component_ion_segment_button, {
                          key: category.id,
                          mode: "ios",
                          value: index,
                          onClick: ($event: any) => ($options.onSegmentChange(category.id))
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(category.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["value", "onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_ion_skeleton_text, {
                    key: 1,
                    class: "ion-segment-skeleton",
                    animated: ""
                  })),
              (!$setup.loadingRef)
                ? (_openBlock(), _createBlock(_component_ion_list, { key: 2 }, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.establishmentRef.productTypes, (category, index) => {
                        return (_openBlock(), _createBlock("div", {
                          id: `category${category.id}`,
                          key: category.id
                        }, [
                          (index > 0)
                            ? (_openBlock(), _createBlock(_component_ion_list_header, {
                                key: 0,
                                class: "category-name"
                              }, {
                                default: _withId(() => [
                                  _createTextVNode(_toDisplayString(category.name), 1)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(category.products, (product) => {
                            return (_openBlock(), _createBlock(_component_ion_item, {
                              key: product.id,
                              lines: "none",
                              class: "no-padding"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_ProductCard, { product: product }, null, 8, ["product"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ], 8, ["id"]))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_Fragment, { key: 3 }, _renderList(5, (i) => {
                    return _createVNode(_component_product_card_skeleton, { key: i })
                  }), 64))
            ])
          ])
        ]),
        _: 1
      }, 512),
      (!$setup.loadingRef)
        ? (_openBlock(), _createBlock(_component_ion_footer, { key: 0 }, {
            default: _withId(() => [
              ($setup.establishmentRef.open == 'N')
                ? (_openBlock(), _createBlock(_component_ion_toolbar, {
                    key: 0,
                    class: "closed-establishment-toolbar",
                    translucent: "true"
                  }, {
                    default: _withId(() => [
                      _hoisted_17
                    ]),
                    _: 1
                  }))
                : ($options.cartPrice > 0)
                  ? (_openBlock(), _createBlock(_component_ion_toolbar, { key: 1 }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_button, {
                          shape: "round",
                          expand: "full",
                          onClick: $options.goCart
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_ion_icon, {
                              class: "button-icon",
                              icon: $setup.cart
                            }, null, 8, ["icon"]),
                            _hoisted_18,
                            _hoisted_19,
                            _createVNode("span", _hoisted_20, _toDisplayString($options.moneyMask($options.cartTotalPrice)), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
})